// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AvailableSlotsPicker from '../AvailableSlotsPicker';
import ProviderLocationInfoCard from '../ProviderLocationInfoCard';
/* eslint-disable no-unused-vars */
import {
  ProviderMappingResult,
  ReferralProfile,
  AppointmentSlot,
} from '../types';
/* eslint-enable no-unused-vars */
import classes from './MatchingResult.module.scss';

/** @typedef {{
  matchingResult: ProviderMappingResult,
  referralProfile: ReferralProfile,
  onSlotClick: (slot: AppointmentSlot) => void,
  onProviderClick: (result: ProviderMappingResult) => void,
  onOrganizationClick: (organizationId: string) => any,
}} MatchingResultPropsType */

const propTypes = {
  matchingResult: PropTypes.object.isRequired,
  referralProfile: PropTypes.object.isRequired,
  onSlotClick: PropTypes.func.isRequired,
  onProviderClick: PropTypes.func.isRequired,
  onOrganizationClick: PropTypes.func.isRequired,
};

/** @type { React.FC<MatchingResultPropsType> } */
const MatchingResult = ({
  matchingResult,
  referralProfile,
  onSlotClick,
  onProviderClick,
  onOrganizationClick,
}) => {
  const { earliestAppointmentTime } = matchingResult;

  const hasSlots = !!earliestAppointmentTime;
  const specId = hasSlots ? 'result-with-slots' : 'result-without-slots';

  return (
    <div
      data-spec-id={specId}
      data-spec-class="matching-result"
      className={cx(
        classes.result_container,
        hasSlots ? classes.has_appts : classes.no_appts
      )}
    >
      <div className={classes.MatchingResult}>
        <ProviderLocationInfoCard
          matchingResult={matchingResult}
          referralProfile={referralProfile}
          onProviderClick={onProviderClick}
          onOrganizationClick={onOrganizationClick}
        />
        {hasSlots && (
          <div className={classes.slot_picker_container}>
            <AvailableSlotsPicker
              matchingResult={matchingResult}
              onSlotClick={onSlotClick}
              shortenSlotList
            />
          </div>
        )}
      </div>
    </div>
  );
};

MatchingResult.displayName = 'MatchingResult';
MatchingResult.propTypes = propTypes;

export default MatchingResult;
